import React, { useCallback, useContext } from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';

import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';

import { Label } from 'core/components/label';
import LabelWithCopyButton from 'core/components/label-with-copy-button';
import backIcon from 'core/components/screen-header/go-to.svg';
import agencyIcon from 'customer/assets/icSold.svg';
import { ElemType, MapClassesToElem } from 'core/helpers/styles-helpers';
import { get, policyTypes } from 'core/helpers/lookups';
import { useStore } from 'core/store';
import FrontContact from 'customer/components/front-contact/front-contact';
import { AuthContext } from 'core/components/auth';
import { Tag } from 'core/components/tag';

import useStyles from './policy-header.styles';

const getPolicyType = get(policyTypes);

const PolicyHeader = ({ history }) => {
  const store = useStore();
  const { account: accountStore } = store;
  const policy = accountStore?.policies?.policy?.policy;
  const { policyId, id } = useParams();
  const accountId = accountStore.id || id;
  const { isExternalSales } = useContext(AuthContext);
  const classes = useStyles();

  const titleText = () => {
    return policy?.id && policy?.id === policyId
      ? `${accountStore.fname} ${accountStore.lname}/${getPolicyType(policy.policyType)} Policy`
      : accountStore.accountLoading
      ? 'Loading...'
      : `${accountStore.fname} ${accountStore.lname}/Loading...`;
  };

  const title = titleText();

  const logRocketURL = policy?.offer?.logrocketSessionURL;

  const onBack = useCallback(() => {
    history.push(`/customer/${accountId}`);
  }, [accountId, history]);

  return (
    <Grid container className={classes.header} justifyContent="space-between">
      <Grid item className={classes.container}>
        <IconButton classes={MapClassesToElem(ElemType.IconButton, classes)} onClick={onBack}>
          <img src={backIcon} className={classes.icon} alt="back" />
        </IconButton>
        <Label type="title">{title}</Label>
        {!isExternalSales && <FrontContact />}
      </Grid>
      <Grid item className={classes.rightContainer}>
        <>
          {policy?.isAgentSold && !isExternalSales && (
            <div className={classes.rightSideInfo}>
              <Tag className={classes.agencyTag}>
                <img alt="agency sold icon" src={agencyIcon} />
                Agency policy
              </Tag>
            </div>
          )}
          <div className={classes.rightSideInfo}>
            <Label type="infoLabel" className={classes.rightLabel}>
              PolicyID
            </Label>
            <LabelWithCopyButton type="body3Bold">{policyId}</LabelWithCopyButton>
          </div>
          <div className={classes.rightSideInfo}>
            <Label type="infoLabel" className={classes.rightLabel}>
              Log Rocket
            </Label>
            <Label type="infoValue" className={classes.rightValue}>
              {logRocketURL ? (
                <a className={classes.link} href={logRocketURL} target="_blank" rel="noopener noreferrer">
                  View purchase
                </a>
              ) : (
                'No session'
              )}
            </Label>
          </div>
        </>
      </Grid>
    </Grid>
  );
};

export default observer(PolicyHeader);
